import classNames from 'classnames';
import {
  dataTypeArray,
  dataTypeKeys,
  dataTypeLabels,
  dateFormatArray,
  dateFormatKeys
} from '../../../../../../../consts/conditions';
import ConditionalInput from '../ConditionalInput';
import { RenameContainerStyle, RenameListStyle } from './style';

import ArrowRightIcon from '../../../../../../../assets/icons/arrow-line-right.svg?react';
import React, { useState } from 'react';
import { ActionIcon, Button, Checkbox, Flex, rem, Tooltip } from '@mantine/core';
import { FaPlus, FaRegCircleQuestion, FaRegTrashCan } from 'react-icons/fa6';
import { IoIosArrowDown } from 'react-icons/io';
import MultiSelectWithInsert from '../MultiSelectWithInsert';

export const ChangeDataTypes = ({
  onChangeInput,
  onChangeColumn,
  filterTypes,
  columns,
  onAddFilterType,
  onDeleteSelectedItems,
  onChangeCurrentFormats
}) => {
  const [selectedItemsIds, setSelectedItemsIds] = useState([]);

  const onDelete = id => {
    const newSelectedItemsIds = selectedItemsIds.filter(itemId => itemId !== id);

    onDeleteSelectedItems(id, newSelectedItemsIds);
    setSelectedItemsIds([]);
  };

  const onSelect = id => {
    const newSelectedItemsIds = [...selectedItemsIds, id];

    setSelectedItemsIds(
      selectedItemsIds.find(itemId => itemId === id)
        ? selectedItemsIds.filter(itemId => itemId !== id)
        : newSelectedItemsIds
    );
  };

  return (
    <div id="grid-table-change-data-types-root" className="">
      <Flex
        id="grid-table-change-data-types-header"
        w="100%"
        justify="flex-end"
        h={rem(40)}
        align="center"
      >
        {selectedItemsIds.length > 0 && (
          <Button
            id="grid-table-change-data-types-delete-selected"
            size="sm"
            variant="transparent"
            onClick={onDelete}
            c="red"
            leftSection={<FaRegTrashCan fontSize="12px" />}
          >
            Delete ({selectedItemsIds.length})
          </Button>
        )}
      </Flex>

      <div
        id="grid-table-change-data-types-card"
        className={classNames('filter_card', {
          ['noBorderBottom']: true,
          ['noBeforeLine']: true,
          ['noBorderTop']: true
        })}
      >
        <div id="grid-table-change-data-types-content" className="filter_content">
          <RenameListStyle id="grid-table-change-data-types-list">
            {filterTypes?.map(filterType => (
              <Section
                key={filterType?.id}
                sectionId={filterType?.id}
                columns={columns}
                oldColumn={filterType.column}
                newColumn={filterType.value.column}
                onSelect={() => onSelect(filterType.id)}
                isSelected={selectedItemsIds.includes(filterType.id)}
                errors={filterType.errors}
                currentFormats={filterType.currentFormats}
                onDelete={() => onDeleteSelectedItems(filterType.id, [filterType.id])}
                onChangeCurrentFormats={val =>
                  onChangeCurrentFormats(filterType.id, filterType.id, val)
                }
                onChangeNewName={val => onChangeInput(filterType.id, filterType.id, val)}
                onChangeOldColumn={val => onChangeColumn(filterType?.id, filterType?.id, val)}
              />
            ))}

            <div id="grid-table-change-data-types-actions" className="actions">
              <ActionIcon
                id="grid-table-change-data-types-add"
                size="sm"
                w={rem(32)}
                h={rem(16)}
                variant="outline"
                onClick={() => onAddFilterType(true)}
              >
                <FaPlus fontSize="12px" />
              </ActionIcon>
            </div>
          </RenameListStyle>
        </div>
      </div>
    </div>
  );
};

const Section = ({
  sectionId,
  columns,
  onChangeNewName,
  onChangeOldColumn,
  oldColumn,
  newColumn,
  isSelected,
  onSelect,
  errors,
  currentFormats,
  onChangeCurrentFormats
}) => {
  const rootId = sectionId
    ? `grid-table-change-data-types-section-${sectionId}`
    : 'grid-table-change-data-types-section';

  const isValueKey = newColumn && dataTypeArray.some(type => type.value === newColumn);
  const type = isValueKey ? dataTypeLabels[newColumn] : newColumn;
  const showOptionalInputs =
    type === dataTypeKeys.DATE || type === dataTypeLabels[dataTypeKeys.DATE];
  const staticValues = dateFormatArray
    .filter(item => item.value !== dateFormatKeys.YMD_HMS)
    .map(item => item.label);
  const manualValues = currentFormats?.filter(el => !staticValues?.includes(el)) || [];

  return (
    <RenameContainerStyle id={rootId}>
      <Checkbox
        id={`${rootId}-select`}
        size="xs"
        mb={rem(7)}
        checked={isSelected}
        onClick={onSelect}
      />

      <label id={`${rootId}-column-label`}>
        <span>
          Column<span className="required">*</span>
        </span>
        <ConditionalInput
          id={`${rootId}-column-input`}
          type="column"
          columns={[...columns].filter(el => el)}
          value={oldColumn}
          onChangeValue={onChangeOldColumn}
          hasRequiredError={errors?.includes('column')}
          placeholder="Select Column"
          hiddenVariants={['null', 'column', 'input', 'ai_input']}
        />
      </label>
      <span id={`${rootId}-arrow`} className="arrow">
        <ArrowRightIcon />
      </span>
      <label id={`${rootId}-type-label`}>
        <span>
          Data Type<span className="required">*</span>
        </span>
        <ConditionalInput
          id={`${rootId}-type-input`}
          type="column"
          inputType="column"
          placeholder="Select Data Type"
          columns={dataTypeArray.map(type => type.label)}
          hasRequiredError={errors?.includes('value')}
          value={type}
          onChangeValue={onChangeNewName}
          hiddenVariants={['null', 'column', 'input', 'ai_input']}
        />
      </label>

      {showOptionalInputs && (
        <>
          <label id={`${rootId}-formats-label`}>
            <Flex id={`${rootId}-formats-row`} align="center" fz={12} fw={600} gap={6}>
              Current Formats{' '}
              <Tooltip
                label={
                  <>
                    Please use this formats
                    <br /> to create unlisted format: <br />
                    %Y-%m-%d %H:%M:%S <br />
                    %Y-%m-%d
                    <br /> %Y/%m/%d
                    <br /> %d-%m-%Y
                    <br /> %d/%m/%Y <br />
                    %m-%d-%Y
                  </>
                }
              >
                <button id={`${rootId}-formats-help`}>
                  <FaRegCircleQuestion color="#228BE6" />
                </button>
              </Tooltip>
            </Flex>
            <MultiSelectWithInsert
              id={`${rootId}-multi-select`}
              size="xs"
              data={[...manualValues, ...staticValues]}
              placeholder="Select"
              value={currentFormats}
              onChange={onChangeCurrentFormats}
              insertPlaceholder="Search or insert"
              w="100%"
              rightSection={<IoIosArrowDown />}
              manualValues={manualValues}
            />
          </label>
        </>
      )}
    </RenameContainerStyle>
  );
};
